import { State, Selector, Action, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';
import { CartClient, CartModel, ClearCartCommand } from '@core/services/api.service';
import { Injectable } from '@angular/core';
import { ClearSearchTextAction, StoreSearchTextAction } from './search.actions';

export class SearchStateModel {
    public searchText: string;
}

@State<SearchStateModel>({
    name: 'search',
    defaults: {
        searchText: ''
    }
})

@Injectable()
export class SearchState {
    constructor() { }

    @Selector()
    static searchText(state: SearchStateModel) {
        return state.searchText;
    }

    @Action(StoreSearchTextAction)
    storeSearchTextAction(ctx: StateContext<SearchStateModel>, action: StoreSearchTextAction) {
        ctx.patchState({
            searchText: action.payload.text,
        });

    }

    @Action(ClearSearchTextAction)
    clearSearchTextAction(ctx: StateContext<SearchStateModel>, action: ClearSearchTextAction) {
        ctx.patchState({
            searchText: ''
        });
    }
}
